import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header";
import SideMenu from "../SideMenu";
import { useIdleTimer } from 'react-idle-timer'

const Layout = () => {
  const onIdle = () => {
    if(JSON.parse(localStorage.getItem("userSession")) <= new Date().getTime()) {
      localStorage.removeItem("userCredential");
      localStorage.removeItem("userSetting");
      localStorage.removeItem("userSettingData");
      localStorage.removeItem("userSession");
      localStorage.removeItem("navMenu");
      window.location.reload();
    }
  }

  const onActive = () => {
    if(JSON.parse(localStorage.getItem("userSession")) <= new Date().getTime()) {
      localStorage.removeItem("userCredential");
      localStorage.removeItem("userSetting");
      localStorage.removeItem("userSettingData");
      localStorage.removeItem("userSession");
      localStorage.removeItem("navMenu");
      window.location.reload();
    }
  }

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    timeout: 3600000,
    throttle: 500
  })

  return (
    <div id="layout-wrapper">
      <Header />
      <div style={{marginTop:"15px"}}></div>
      <SideMenu />
      <div className="main-content">
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
